<template>
  <div class="safedig-grants">
    <section class="safedig-grants-hero" :style="{ backgroundImage: `url(${heroBgImage})` }">
      <div class="safedig-grants-hero-overlay">
        <h1 class="safedig-grants-hero-title">{{ $t('grants.heroTitle') }}</h1>
        <p class="safedig-grants-hero-subtitle">
          {{ $t('grants.heroSubtitle') }}
        </p>
      </div>
    </section>

    <section class="safedig-grants-content">
      <div class="safedig-grants-content-inner">
        <p class="safedig-grants-intro">
          {{ $t('grants.intro') }}
        </p>

        <h2 class="safedig-grants-heading">{{ $t('grants.completingApplication') }}</h2>
        <p class="safedig-grants-body">
          <i18n path="grants.downloadInstruction" tag="span">
            <template #appLink>
              <a href="#" class="safedig-grants-link">{{ $t('grants.uppaGrantApp') }}</a>
            </template>
            <template #instructionsLink>
              <a href="#" class="safedig-grants-link">{{ $t('grants.uppaGrantInstructions') }}</a>
            </template>
          </i18n>
        </p>

        <div class="safedig-grants-buttons">
          <a href="#" class="safedig-grants-btn">{{ $t('grants.btnGrantApp') }}</a>
          <a href="#" class="safedig-grants-btn">{{ $t('grants.btnGrantInstructions') }}</a>
        </div>

        <div class="safedig-grants-note">
          <strong>NOTE:</strong><br>
          <span>{{ $t('grants.note') }}</span>
        </div>

        <p class="safedig-grants-body">
          {{ $t('grants.fillOutFields') }}
        </p>
        <p class="safedig-grants-body">
          <i18n path="grants.questionsDirectTo" tag="span">
            <template #email>
              <a href="mailto:DarbMiller@urc.in.gov" class="safedig-grants-link">DarbMiller@urc.in.gov</a>
            </template>
            <template #legalEmail>
              <a href="mailto:URCGeneralCounsel@urc.in.gov" class="safedig-grants-link">URCGeneralCounsel@urc.in.gov</a>
            </template>
          </i18n>
        </p>
        <p class="safedig-grants-body">
          <i18n path="grants.completedTo" tag="span">
            <template #email>
              <a href="mailto:DarbMiller@urc.in.gov" class="safedig-grants-link">DarbMiller@urc.in.gov</a>
            </template>
          </i18n>
        </p>

        <h3 class="safedig-grants-subheading">{{ $t('grants.grantingOfFunds') }}</h3>
        <p class="safedig-grants-body">
          {{ $t('grants.grantingPara1') }}
        </p>
        <p class="safedig-grants-body">
          {{ $t('grants.grantingPara2') }}
        </p>
        <p class="safedig-grants-body">
          {{ $t('grants.grantingPara3') }}
        </p>
        <p class="safedig-grants-body">
          {{ $t('grants.grantingPara4') }}
        </p>
        <p class="safedig-grants-body">
          <i18n path="grants.clickHereLink" tag="span">
            <template #link>
              <a href="https://www.urc.in.gov/grant-request-forms" target="_blank" rel="noopener noreferrer">{{ $t('grants.clickHere') }}</a>
            </template>
          </i18n>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
const heroBgImage = require('@/assets/safe-dig/uppa_cropped_scaled.png');

export default {
  name: 'SafeDigGrants',
  data() {
    return {
      heroBgImage
    };
  }
};
</script>

<style scoped>
.safedig-grants {
  width: 100%;
  padding-top: 26px;
}

.safedig-grants-hero {
  position: relative;
  width: 100%;
  min-height: 465px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.safedig-grants-hero-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  background-color: rgba(0, 0, 0, .4);
}

.safedig-grants-hero-title {
  font-size: 60px;
  line-height: 1.5;
  font-weight: 700;
  color: #fff;
  margin: 0;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.safedig-grants-hero-subtitle {
  font-size: 20px;
  padding: 16px 14%;
  color: #fff;
  margin: 0;
  text-align: center;
  line-height: 22px;
}

.safedig-grants-content {
  padding: 3rem 0rem;
  background: #fff;
}

.safedig-grants-content-inner {
  max-width: 1200x;
  margin: 0 auto;
}

.safedig-grants-intro {
  font-size: 1rem;
  color: #1e3a5f;
  line-height: 1.6;
  margin-bottom: 2rem;
}

.safedig-grants-heading {
  font-size: 1.25rem;
  font-weight: 700;
  color: #3d4852;
  margin-bottom: 1rem;
}

.safedig-grants-body {
  font-size: 16px;
  color: #3d4852;
  line-height: 1.6;
  margin: 0 0 1rem;
}

.safedig-grants-link {
  color: #3e7799;
  text-decoration: underline;
}

.safedig-grants-link:hover {
  color: #2d4b6c;
}

.safedig-grants-buttons {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 1.5rem 0;
}

.safedig-grants-btn {
  display: inline-block;
  padding: 5px 10px;
  background: #edcd00;
  color: #2d4b6c;
  font-weight: 700;
  text-decoration: none;
  transition: background 0.2s;
  max-width: 30%;
  font-size: 25px;
  text-align: center;
  line-height: 24px;
}

.safedig-grants-btn:hover {
  background: #e5b520;
}

.safedig-grants-note {
  padding: 1rem 1rem 1rem 1.5rem;
  margin: 50px 0 20px;
  border-left: 20px solid #3d4852;
  border-radius: 7.5px;
  background: #f5f8fa;
  color: #3d4852;
  font-size: 1rem;
  line-height: 1.5;
}

.safedig-grants-note span {
  font-size: 16px;
}

.safedig-grants-subheading {
  font-size: 1.1rem;
  font-weight: 700;
  color: #3d4852;
  margin: 2rem 0 1rem;
}

@media (max-width: 768px) {
  .safedig-grants-hero-title {
    font-size: 1.75rem;
  }

  .safedig-grants-hero-subtitle {
    font-size: 1rem;
  }
}

@media (max-width: 576px) {
  .safedig-grants-btn {
    font-size: 18px;
    max-width: 100%;
  }
}
</style>
